import { render, staticRenderFns } from "./patient.vue?vue&type=template&id=11212244&scoped=true"
import script from "./patient.vue?vue&type=script&lang=js"
export * from "./patient.vue?vue&type=script&lang=js"
import style0 from "./patient.vue?vue&type=style&index=0&id=11212244&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11212244",
  null
  
)

export default component.exports